
export const calculateSummary = (dataList) => {
    console.log("calculating summary")
    let frequency = {};
    let consecutiveMisses = {};
    let avgConsecutiveMisses = {};
    let maxConsecutiveMisses = {};
    let MaxConsecutiveHits = {};
    
    // calculate frequency and consecutive misses object
    let zeroAlreadyFound = {}
    dataList.forEach((data, dataIndex) => {
        let prevData = dataIndex === 0 ? null : dataList[dataIndex - 1]

        Array.from({"length": 90}, (_, index) => {
            let name = (index + 1).toString().padStart(2, '0')

            // 1. FREQUENCY CALC
            if (frequency[name] === undefined) {
                frequency[name] = 0
            }
            frequency[name] = data.omissions[name] === 0 ? frequency[name] + 1 : frequency[name]  

            // 2. MISSES CALC
            if (consecutiveMisses[name] === undefined) {
                consecutiveMisses[name] = []
                MaxConsecutiveHits[name] = 0
                zeroAlreadyFound[name] = false
            }

            // if 0 is found
            if (data.omissions[name] === 0) {
                // if previous data value is not zero and null
                if (prevData !== null && prevData.omissions[name] !== 0) {                        
                    // if this is not the first zero found
                    if (zeroAlreadyFound[name]) {
                        consecutiveMisses[name].push(prevData.omissions[name]) 
                    } else {
                        consecutiveMisses[name].push((prevData.omissions[name] + 1) - dataList[0].omissions[name])        
                    }
                }
                zeroAlreadyFound[name] = true

                // check and update consecutive hits
                let i = 0
                while (dataIndex - i >= 0 && dataList[dataIndex - i].omissions[name] === 0) {
                    i += 1
                    MaxConsecutiveHits[name] = 0
                }
                MaxConsecutiveHits[name] = i > MaxConsecutiveHits[name] ? i : MaxConsecutiveHits[name]

            }else {
                // if its the last data
                if (dataIndex === dataList.length - 1) {
                    // if this is not the first zero found
                    if (zeroAlreadyFound[name]) {
                        consecutiveMisses[name].push(data.omissions[name]) 
                    } else {
                        consecutiveMisses[name].push((data.omissions[name] + 1) - dataList[0].omissions[name])        
                    }    
                }
            }
            return null
        })
    })

    // calculate the average and maximum consecutive misses from the consecutive misses calculated
    Array.from({"length": 90}, (_, index) => {
        let name = (index + 1).toString().padStart(2, '0')
        maxConsecutiveMisses[name] = Math.max(...consecutiveMisses[name])
        let sum = 0;
        consecutiveMisses[name].forEach((miss) => {
            sum += miss
        })
        avgConsecutiveMisses[name] = Math.floor(sum / consecutiveMisses[name].length)
        return null
    })

    return {
        "Frequency":frequency, 
        "Avg Successive Misses":avgConsecutiveMisses, 
        "Max Successive Misses":maxConsecutiveMisses, 
        "Max Successive Hits":MaxConsecutiveHits
    }
}